import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
// Components
import { FormArrayTableComponent } from './components/form-array-table/form-array-table.component';
import { PublicRegistrySearchComponent } from './components/public-registry-search/public-registry-search.component';
// Pipes
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { SafePipe } from 'common/pipes/safe.pipe';
import { NumericFormatDirective } from './directives/numeric-format/numeric-format.directive';
import { SsnPipe } from './pipes/ssn.pipe';
import { TranslationPipe, TranslationPluralPipe } from './pipes/translate.pipe';

@NgModule({
    declarations: [
        // Components
        FormArrayTableComponent,
        PublicRegistrySearchComponent,
        // Directives
        NumericFormatDirective,
        // Pipes
        SafePipe,
        TranslationPipe,
        TranslationPluralPipe,
        SsnPipe,
    ],
    imports: [
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatTableModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatIconModule,
        ReactiveFormsModule,
        MatInputModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        CommonModule,
    ],
    exports: [
        // Components
        FormArrayTableComponent,
        PublicRegistrySearchComponent,
        // Directives
        NumericFormatDirective,
        // Pipes
        SafePipe,
        TranslationPipe,
        TranslationPluralPipe,
        SsnPipe,
    ],
})
export class LsrCommonModule {}
